import { MultipleChoiceOption } from "./multipleChoiceOption";
import { MultipleChoiceQuiz } from "./multipleChoiceQuiz";
export class TextMultipleChoiceQuiz extends MultipleChoiceQuiz {
    getQuestion() {
        return this._data.question;
    }
    getOptions() {
        let options = new Array();
        let optionDatas = this._data.options;
        for (let optionData of optionDatas) {
            options.push(new MultipleChoiceOption(optionData.id, optionData.text, optionData.isCorrect, optionData.explanation));
        }
        if (this._isRandomize) {
            options.sort(() => Math.random() - 0.5);
        }
        return options;
    }
}
